import { render, staticRenderFns } from "./CallReportsFilters.vue?vue&type=template&id=56d87e24&"
import script from "./CallReportsFilters.vue?vue&type=script&lang=js&"
export * from "./CallReportsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports